export default {
    NACIONAL: 1,
    INTERNACIONAL: 2,
}